import {Member} from "./Models";
import {API_BASE} from "./ApiClient";

import axios, {AxiosResponse} from 'axios';

export default class MemberApi {
  private jwtToken: string|null

  constructor(jwtToken: string|null) {
    this.jwtToken = jwtToken
  }

  members(systemId: string): Promise<Member[]> {
    return axios.get(API_BASE + '/systems/' + systemId + '/members', {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<Member[]>) => {
        return response.data;
      })
  }

  addMember(systemId: string, name: string): Promise<Member> {
    return axios.post(API_BASE + '/systems/' + systemId + '/members', {
      name
    }, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<Member>) => {
        return response.data;
      })
  }

  updateMember(memberId: string, member: Partial<Member>): Promise<Member> {
    return axios.put(API_BASE + '/members/' + memberId, {
      ...member
    }, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<Member>) => {
        return response.data;
      })
  }

  removeMember(id: string): Promise<void> {
    return axios.delete(API_BASE + '/members/' + id, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<void>) => {
        return
      })
  }
};